export default class SampleConfig { 
	public static Xml = `<?xml version=\"1.0\" encoding=\"utf-16\"?>
<!-- SDS dates will only process teams created within this date range through SDS for the organisation -->
<SchoolWorkloadConfig SDSStartDate=\"2023-08-01\" SDSEndDate=\"2024-07-01\">
	
    <SubjectMerges megamenuMyListName=\"Subjects\" Notebook=\"false\">

		<!-- Additional Staff Groups for subject sites -->
		<!-- Adding additional Staff Group called \"All NonTeaching Staff\" with edit access to all subject sites -->
		<AdditionalGroupPattern Type=\"Staff\" AddSchoolCodePrefix=\"true\" AddSubjectCodePrefix=\"false\" Name=\"All NonTeaching Staff\" Level=\"contribute\" />
		<!-- Adding additional Staff Group called \"All NonTeaching Staff\" with read access to one subject site with the code \"en\" -->
		<SpecificAdditionalGroup Type=\"Staff\" AddSchoolCodePrefix=\"false\" AddSubjectCodePrefix=\"false\" Name=\"All NonTeaching Staff\" Level=\"read\" SubjectCode=\"en\" />
		<!-- Adding additional Staff Group called \"SCH SubjectCode Additional Staff\" with read access to all subject sites. e.g. the name of the group will be different for each subject e.g. \"CAA En Additional Staff\" -->
		<AdditionalGroupPattern Type=\"Staff\" AddSchoolCodePrefix=\"true\" AddSubjectCodePrefix=\"true\" Name=\"Additional Staff\" Level=\"read\" />
		  
		<!-- Additional Student Groups for subject sites -->
		<!-- Adding the group \"All Students\" with read access to all subject sites (student view only) -->
		<AdditionalGroupPattern Type=\"Student\" AddSchoolCodePrefix=\"true\" AddSubjectCodePrefix=\"false\" Name=\"All Students\" Level=\"read\" />
		<!-- Adding the group \"All Students\" with read access to just the En subject site (student view only) -->
		<SpecificAdditionalGroup Type=\"Student\" AddSchoolCodePrefix=\"false\" AddSubjectCodePrefix=\"false\" Name=\"All Students\" Level=\"read\" SubjectCode=\"en\" />

		<!-- Additional Student Library for all subject sites -->
		<AdditionalLibrary Type=\"Student\" Name=\"Revision\" AllSubjectCodes=\"true\"/> 
		<!-- Additional Staff Library for specific subject sites -->
		<AdditionalLibrary Type=\"Staff\" Name=\"Staff Archive\" TargetSubjectCodes=\"En,Hi\"/> 
		  
    </SubjectMerges>
	
    <!-- comma seperate subject codes to exclude -->
    <SubjectExcludes SourceSubjectCodes=\"Zz1,ZZ2\" />
	
    <Departments>
	
		<!-- example of adding a staff department team for science with school prefix - ideal for individual schools in a trust. e.g. this example would create \"CAA Science Staff\" -->
		<Department StaffTemplate=\"true\" enablePrefix=\"true\" Name=\"Science\" SourceSubjectCodes=\"Bi,Ph,Ch\" />
		<!-- example of adding a staff department team for science without a school prefix - ideal for trust department teams (same line would need adding to all school configs with the relevant subject codes for that school. e.g. this example would create \"Trust Science Staff\" -->
		<Department StaffTemplate=\"true\" enablePrefix=\"false\" Name=\"Trust Science\" SourceSubjectCodes=\"Bi,Ph,Ch\" />
		
    </Departments>
	
    <!-- agggregate permissions means that a year 9 student would also have access to any year groupings that come before it using the IsAfter parameter-->
    <YearGroupings AggregatePermissions=\"true\">
	
		<!-- year group example -->
		<!-- default year and key stage metadata is optional for each year grouping when creating subject sites-->
		<YearGrouping Name=\"Year 07\" MetadataYearValue=\"Year 7\" MetadataKSValue=\"KS3\" Years=\"7\" />
		<YearGrouping Name=\"Year 08\" IsAfter=\"Year 07\" MetadataYearValue=\"Year 8\" MetadataKSValue=\"KS3\" Years=\"8\" />
		<YearGrouping Name=\"Year 09\" IsAfter=\"Year 08\" MetadataYearValue=\"Year 9\" MetadataKSValue=\"KS3\" Years=\"9\" />
		<YearGrouping Name=\"Year 10\" IsAfter=\"Year 09\" MetadataYearValue=\"Year 10\" MetadataKSValue=\"KS4\" Years=\"10\" />
		<YearGrouping Name=\"Year 11\" IsAfter=\"Year 10\" MetadataYearValue=\"Year 11\" MetadataKSValue=\"KS4\" Years=\"11\" />
		<YearGrouping Name=\"Year 12\" IsAfter=\"Year 11\" MetadataYearValue=\"Year 12\" MetadataKSValue=\"KS5\" Years=\"12\" />
		<YearGrouping Name=\"Year 13\" IsAfter=\"Year 12\" MetadataYearValue=\"Year 13\" MetadataKSValue=\"KS5\" Years=\"13\" />
		<!--Key stage example-->
		<YearGrouping Name=\"KS3\" MetadataKSValue=\"KS3\" Years=\"07,8,9\" />
		<YearGrouping Name=\"KS4\" IsAfter=\"KS3\" MetadataKSValue=\"KS4\" Years=\"10,11\" />
		<YearGrouping Name=\"KS5\" IsAfter=\"KS4\" MetadataKSValue=\"KS5\" Years=\"12,13\" />
		<!--Course example-->
		<YearGrouping Name=\"KS3\" MetadataKSValue=\"KS3\" Years=\"07,8,9\" />
		<YearGrouping Name=\"GCSE\" IsAfter=\"KS3\" MetadataKSValue=\"KS4\" Years=\"10,11\" />
		<YearGrouping Name=\"A-Level\" IsAfter=\"GCSE\" MetadataKSValue=\"KS5\" Years=\"12,13\" />
		
    </YearGroupings>
	
	<!-- Extra teams such as all teachers team-->
	<ExtraTeams EnableAllTeachersTeam=\"true\" EnableAllStaffTeam=\"true\" />
	
</SchoolWorkloadConfig>`
}